<!-- Created by henian.xu on 2021/9/6. -->

<template>
    <div class='high-meter-discern'>
        <div
            class='out-show'
            @click="()=>{onPicker()}">
            <slot>
                <el-button
                    type="primary"
                    size="small"
                >{{ buttonLabel }}
                </el-button>
            </slot>
        </div>
        <el-dialog
            title="高拍仪作业"
            :visible.sync="dialog.visible"
            append-to-body
            fullscreen
            center
            :show-close="false"
            :destroy-on-close="true"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
        >
            <div
                style="min-height: 300px"
                v-loading="!bigPriDev || isUploading"
                element-loading-text="请稍候..."
            >
                <el-row
                    v-show="bigPriDev"
                    class="device-preview-wrap"
                    :gutter="20"
                >
                    <el-col
                        v-if="bigPriDev"
                        class="item"
                        :span="8"
                    >
                        <img
                            :src="bigPriDev"
                            alt="主头设备预览"
                        >
                    </el-col>
                    <el-col :span="16">
                        <el-form
                            v-show="!isUploading"
                            label-width="8em"
                            size="mini"
                        >
                            <el-form-item label="设置尺寸:">
                                <el-select
                                    v-model="formModel.scanSize"
                                    @input="onScanSizeInput"
                                >
                                    <el-option
                                        v-for="item in state.scanSize"
                                        :key="item.id"
                                        :label="item.label"
                                        :value="item.id"
                                    />
                                </el-select>
                                <el-select
                                    class="ma-l"
                                    v-model="formModel.priResolution"
                                    @input="onPriResolutionInput"
                                >
                                    <el-option
                                        v-for="(item) in state.priResolution"
                                        :key="'PriDev'+item"
                                        :label="item"
                                        :value="item"
                                    />
                                </el-select>
                            </el-form-item>
                            <el-form-item label="出图格式:">
                                <el-select v-model="formModel.priModel">
                                    <el-option
                                        v-for="item in state.priModel"
                                        :key="item"
                                        :label="item"
                                        :value="item"
                                    />
                                </el-select>
                            </el-form-item>
                            <el-form-item label="纠偏裁边:">
                                <el-checkbox
                                    v-model="formModel.setdeskew"
                                    @input='onSetdeskewInput'
                                >{{ formModel.setdeskew ? '是' : '否' }}
                                </el-checkbox>
                            </el-form-item>
                            <el-form-item label="属性设置:">
                                <el-button
                                    type="primary"
                                    @click="()=>{onShowProperty()}"
                                >
                                    现在设置
                                </el-button>
                            </el-form-item>
                            <el-form-item>
                                <el-button
                                    type="primary"
                                    @click="()=>{onPriDevPhotograph()}"
                                >
                                    拍摄
                                </el-button>
                            </el-form-item>
                        </el-form>
                    </el-col>
                </el-row>
            </div>
            <el-upload
                v-show="false"
                ref="elUpload"
                class="upload-demo"
                :check-type="checkType"
                :action="actionUrl"
                :headers="headers_"
                :file-list="fileList"
                :on-progress="onProgress"
                :on-success="onSuccess"
                :on-error="onError"
                :auto-upload="false"
            >
                <el-button
                    slot="trigger"
                    size="small"
                    type="primary"
                >
                    选取文件
                </el-button>
                <div
                    slot="tip"
                    class="el-upload__tip"
                >
                    只能上传jpg/png文件，且不超过500kb
                </div>
            </el-upload>
            <div
                v-if='currentFile'
                class="high-meter-discern-photograph">
                <div
                    v-if='currentFile.status === "error"'
                    class='tc-danger'>{{ currentFile.error }}
                </div>
                <el-row
                    v-else
                    :gutter="20">
                    <el-col :span='8'>
                        <template v-if='currentFile.status === "success"'>
                            <img
                                class="img-obj"
                                :src="currentFile.blob"
                                alt="tmp"
                            >
                        </template>
                        <div
                            class='ta-c'
                            v-else-if='currentFile.status === "uploading"'>
                            <el-progress
                                style='margin: 0 auto;'
                                type="circle"
                                :percentage="currentFile.percentage|number(0,false)"
                                :width="80"
                            />
                        </div>

                    </el-col>
                    <el-col
                        v-if='currentFile.status === "success"'
                        :span='16'>
                        <el-form
                            ref="submitForm"
                            label-width="8em"
                            size="mini"
                            :model="formModel"
                            :rules="formRules"
                        >
                            <el-form-item
                                label="身份证号:"
                                prop="idCardNo">
                                <el-input v-model="formModel.idCardNo"></el-input>
                            </el-form-item>
                            <el-form-item
                                label="姓名:"
                                prop="fullName">
                                {{ formModel.fullName }}
                            </el-form-item>
                            <el-form-item
                                label="初领日期:"
                                prop="firstClaim">
                                <el-date-picker
                                    type="date"
                                    v-model="formModel.firstClaim"
                                    format="yyyy-MM-dd"
                                    value-format="yyyy-MM-dd"
                                />
                            </el-form-item>
                            <el-form-item
                                label="有效期开始:"
                                prop="effectTime">
                                <el-date-picker
                                    type="date"
                                    v-model="formModel.effectTime"
                                    format="yyyy-MM-dd"
                                    value-format="yyyy-MM-dd"
                                />
                            </el-form-item>
                            <el-form-item
                                label="有效期结束:"
                                prop="expireTime">
                                <el-date-picker
                                    type="date"
                                    v-model="formModel.expireTime"
                                    format="yyyy-MM-dd"
                                    value-format="yyyy-MM-dd"
                                />
                            </el-form-item>
                            <el-form-item
                                label="应复审日期:"
                                prop="reviewTime">
                                <el-date-picker
                                    type="date"
                                    v-model="formModel.reviewTime"
                                    format="yyyy-MM-dd"
                                    value-format="yyyy-MM-dd"
                                />
                            </el-form-item>
                        </el-form>
                    </el-col>
                </el-row>
            </div>
            <div
                slot="footer"
                class="dialog-footer"
            >
                <el-button
                    type="primary"
                    @click="()=>{onComplete()}"
                    :disabled="!currentFile || currentFile.status !== 'success'"
                >
                    提 交
                </el-button>
                <el-button
                    :disabled="isUploading"
                    @click="()=>{onCancel()}"
                >
                    返 回
                </el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import emitter from 'element-ui/src/mixins/emitter';
import {
    close,
    open,
    priPhotograph,
    setdeskew,
    setPriResolution,
    setPriScanSize,
    showProperty,
    state,
    subPhotograph,
} from '@/components/highMeter/store';
import { Utils } from 'vmf';

export default {
    name: 'HighMeterDiscern',
    mixins: [emitter],
    data() {
        return {
            dialog: {
                visible: false,
            },
            state,
            formModel: {
                scanSize: '原始尺寸',
                priModel: 'YUY2',
                priResolution: '2048 * 1536',
                subModel: 'MJPG',
                subResolution: '1920 * 1080',
                setdeskew: false,
                idCardNo: '', // 身份证号
                fullName: '', // 姓名
                firstClaim: '', // 初领日期
                effectTime: '', // 有效期开始
                expireTime: '', // 有效期结束
                reviewTime: '', // 应复审日期
            },
            // 表单校验规则
            formRules: {
                idCardNo: { required: true, message: '不能为空' },
                // fullName: { required: true, message: '不能为空' },
                firstClaim: { required: true, message: '不能为空' },
                effectTime: { required: true, message: '不能为空' },
                expireTime: { required: true, message: '不能为空' },
                reviewTime: { required: true, message: '不能为空' },
            },
            fileList: [],
            isUploading: false,
            closeIng: false,
            currentFile: null,
        };
    },
    props: {
        value: {
            type: Array,
            default: () => [],
        },
        action: {
            type: String,
            default: '',
            required: true,
        },
        buttonLabel: {
            type: String,
            default: '开始识别',
        },
        checkType: {
            type: String,
            default: '',
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        headers: {
            type: Object,
            default: () => ({}),
        },
    },
    computed: {
        headers_() {
            const { headers } = this;
            return {
                // token: Utils.GlobalVar.appConfig.AXIOS_DEFAULT_CONFIG.headers.token,
                // token: this.$store.getters['Global/User/token'],
                ...headers,
            };
        },
        actionUrl() {
            const { action } = this;
            // const baseURL = Utils.GlobalVar.appConfig.AXIOS_DEFAULT_CONFIG.baseURL || '';
            // return baseURL + action;
            return action;
        },
        bigPriDev() {
            return state.bigPriDev;
        },
        bigSubDev() {
            return state.bigSubDev;
        },
        isDisabled() {
            return this.disabled || (this.elForm || {}).disabled;
        },
    },
    methods: {
        async onPicker() {
            if (this.isDisabled) return;
            try {
                await open();
            } catch (e) {
                this.$alert(e, '错误提示');
                return;
            }
            this.dialog.visible = true;
        },
        async onCancel() {
            if (this.closeIng) return;
            this.closeIng = true;
            await close();
            this.dialog.visible = false;
            this.closeIng = false;
        },
        // -------------------------
        async onPriDevPhotograph() {
            const res = await priPhotograph();
            console.log(res);
            this.currentFile = res;

            const $elUpload = this.$refs.elUpload;
            if (!$elUpload || !$elUpload.$refs) return;
            const $uploadInner = $elUpload.$refs['upload-inner'];
            if (!$uploadInner) return;
            $elUpload.clearFiles();
            $uploadInner.uploadFiles([this.currentFile.file]);

            this.$nextTick(() => {
                $elUpload.submit();
                this.isUploading = true;
            });
        },
        async onSubDevPhotograph() {
            await subPhotograph();
        },
        onScanSizeInput(value) {
            setPriScanSize(value);
        },
        onPriResolutionInput(value) {
            setPriResolution(value);
        },
        onSetdeskewInput(value) {
            setdeskew(value);
        },
        onShowProperty() {
            showProperty();
        },
        // -------------------------
        onProgress(event, file /* , fileList */) {
            const { percentage, status } = file;
            const { currentFile } = this;
            if (!currentFile) return;
            currentFile.progress = percentage;
            currentFile.status = status;
        },
        onSuccess(response, file /* , fileList */) {
            const { data, success, msg } = response;
            const { status } = file;
            const { currentFile, formModel } = this;
            if (!currentFile) return;
            currentFile.response = data;
            const { initData } = data;
            if (initData) {
                this.formModel.idCardNo = ''; // 身份证号
                this.formModel.fullName = ''; // 姓名
                this.formModel.firstClaim = ''; // 初领日期
                this.formModel.effectTime = ''; // 有效期开始
                this.formModel.expireTime = ''; // 有效期结束
                this.formModel.reviewTime = ''; // 应复审日期
                Object.keys(initData).forEach(key => {
                    if (Utils.hasOwn(formModel, key)) {
                        formModel[key] = initData[key] || formModel[key] || '';
                    }
                });
            }
            if (success) {
                currentFile.status = status;
            } else {
                currentFile.status = 'error';
                currentFile.error = msg;
            }
            this.setModel();
        },
        onError(err, file /* , fileList */) {
            const { status } = file;
            const { currentFile } = this;
            if (!currentFile) return;
            currentFile.status = status;
            currentFile.error = err;
        },
        setModel() {
            this.isUploading = false;
            // this.onCancel();
        },
        async onComplete() {
            const {
                $refs: { submitForm },
                formModel,
                currentFile,
            } = this;
            await submitForm.validate();
            if (!this.$listeners.submit) return null;
            return new Promise((resolve, reject) => {
                this.$emit('submit', {
                    done: res => {
                        if (res) {
                            this.currentFile = null;
                            formModel.idCardNo = ''; // 身份证号
                            formModel.fullName = ''; // 姓名
                            formModel.firstClaim = ''; // 初领日期
                            formModel.effectTime = ''; // 有效期开始
                            formModel.expireTime = ''; // 有效期结束
                            formModel.reviewTime = ''; // 应复审日期
                            resolve();
                        } else {
                            reject();
                        }
                    },
                    data: {
                        ...formModel,
                        imageName: ((currentFile || {}).response || {}).name || '',
                    },
                });
            });
        },
    },
};
</script>

<style lang='scss'>
.high-meter-discern {
    display: inline-block;

    &-photograph {
        margin-top: $margin-big;

        img {
            width: 100%;
        }
    }
}
</style>
